const GBP = 'GBP';
const USD = 'USD';
const EUR = 'EUR';
const TRY = 'TRY';

// All values are stored as the lowest value for a given currency in our databases.
// For example:
// GBP : Pence
// USD : Cent
// EUR : Cent
// TRY : Kuruş
export const multiplyValueForCurrency = currency => {
  switch (currency) {
    case GBP:
    case USD:
    case EUR:
    case TRY:
      return 100;
    default:
      return 100;
  }
};

// We show different accents for each currency to correctly display prices
export const accentForCurrency = currency => {
  switch (currency) {
    case GBP:
      return '£';
    case USD:
      return '$';
    case EUR:
      return '€';
    case TRY:
      return '₺';
    default:
      return '£';
  }
};

export const getCurrencyList = () => [
  { label: GBP, value: 'gbp' },
  { label: USD, value: 'usd' },
  { label: EUR, value: 'eur' },
  { label: TRY, value: 'tl' },
];

export const getCurrencyForCountry = country => {
  country = country.toUpperCase();

  switch (country) {
    case 'GB':
      return 'gbp';
    case 'ES':
      return 'eur';
    case 'US':
      return 'usd';
    case 'TRY':
      return 'tl';
    default:
      return 'gbp';
  }
};



// WEBPACK FOOTER //
// ./src/utils/currency/currency-utils.js